module.exports = __webpack_public_path__ + "static/media/image_upload_avatar.1f2cc913.svg";